var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('section', { staticClass: "video-processor" }, [_c('div', { staticClass: "processor" }, [_c('upload-form'), _vm._v(" "), _c('instructions')], 1)]);
};
var staticRenderFns = [];

export { render, staticRenderFns };